import '../../../styles/index.css'
import './CardDev.css';
import CustomButton from '../../Buttons/CustomButton/CustomButton';
import Linkedin from '../../../assets/img/Linkedin.svg';
import ExternalPage from '../../../assets/icons/External Page Icon Branco.svg';

function CardDev({ nome, email, foto, cargo, portfolio, linkedin }) {

    return (
        <div className='cardDev container shadow'>

            <div className='d-flex justify-content-around w-100'>
                <img src={foto} className='fotoDev' alt="Foto do Desenvolvedor" data-cy="card-dev-foto"/>

                <div className='text-end'>
                    <h5 data-cy="card-dev-nome">{nome}</h5>
                    <p className='b1' data-cy="card-dev-cargo">{cargo}</p>
                    <p className='b3 mt-2' data-cy="card-dev-email">{email}</p>
                </div>
            </div>

            <div className='d-flex justify-content-around w-100'>
                <a href={portfolio} target='_blank' rel="noreferrer" data-cy="card-dev-portfolio">
                    <CustomButton texto={portfolio.includes('github') ? 'Ver GitHub' : 'Ver Behance'} cor={'#A80A01'} tipo='1' icone={ExternalPage} />
                </a>

                <div className='d-flex align-items-center'>
                    <img src={Linkedin} alt="Icone Linkedin" />
                    <a href={linkedin} target='_blank' rel="noreferrer" style={{ color: '#0077B7', textDecoration: 'underline', fontWeight: 700 }} data-cy="card-dev-linkedin">Linkedin</a>
                </div>

            </div>

        </div>
    );
}

export default CardDev;
